import React, { Component } from "react";

import CountryCodes from "../Codes/CountryCode";
import LanguageCodes from "../Codes/LanguageCode";
import OccupationCodes from "../Codes/Occupation";
import axios from "../../../axios-order";
import SimpleReactValidator from 'simple-react-validator';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
 

class Ilets extends Component {
  constructor(props){
    super(props)          
    this.validator = new SimpleReactValidator();
  }
  state = {
    ieltsDetails: {
      preferred_test_date: '',
      second_test_date:'',
      first_name:'',
      last_name:'',
      title:'',
      city:'',
      address:'',
      telephone:'',
      mobile_number:'',
      email:'',
      zip_code:'',
      dob:'',
      gender:'m',
      identity_proof:'',
      identity_number:'',
      nationality:'',
      nationality_code:'',
      language:'',
      language_code:'',
      occupation_sector_id:'',
      occupation_sector_other:'',
      occupation_level_id:'',
      occupation_level_other:'',
      test_taking_id:'',
      test_taking_other:'',
      country:'',
      country_other:'',
      currently_studying_description:'',
      eduction_level_id:'',
      has_disability:'',
      disability_description:'',
      ielts_module:'',
      document: [],
    },
    dataFile: [],
    error: false,
  };
  handleUserInput = (e) => {
    this.state.dataFile = []
    if (e.target.type === "file") {
      this.fileHandler(e.target.files);
    } else {
      const value = e.target.value;
      this.setState({
        ...this.state,
        ieltsDetails: {
          ...this.state.ieltsDetails,
          [e.target.name]: value,
        },
      });
    }
  };
  fileHandler = (files) => {
    let filesData1 = [];
    let data = [];
    let filesForm = files;
    for (let k of Object.keys(filesForm)) {
      filesData1.push(filesForm[k]);
      this.setState((prevState) => {
        return {
          dataFile: prevState
          .dataFile.push(filesForm[k]),
        };
      });
    }
  
    filesData1.forEach((file) => {
      this.getBase64(file).then((response) => {
        data.push(response);
      });
    });
    this.setState({
      ...this.state,
      ieltsDetails: {
        ...this.state.ieltsDetails,
        documents: data,
      },
    });
  };
  getBase64 = (file) => {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
    });
  };
  submitForm=(e)=>{ 
    if (this.validator.allValid()) {
      console.log(this.state.ieltsDetails)
      this.props.onSetLoader();
      axios.post('registration', this.state.ieltsDetails)
      .then(response => { 
            this.props.onSetLoader();
            this.props.history.replace("/");
            console.log(response)             
      })
      .catch( error => {            
          console.log(error)
          this.props.onSetLoader();
      });
      return true
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
    e.preventDefault();
  }
  render() {
    return (
      <div>
        <div className="banner-image country">
          <div className="mx-width">
            <div className="banner-text">
              <h1 className="bg-text1 mb-1">
                <span className="text-color2">Ielts</span>
              </h1>
            </div>
          </div>
        </div>
        <div className="my-3">
          <h2 className="text-color1 text-center heading2 mb-0">
            Fill the Form
          </h2>
        </div>
        <div className="form-section">
          <div className="ms-width">
            <form action="" method="post">
              <div className="form-container mb-4">
                <div className="d-flex">
                  <h4 className="heading4 text-color2 mb-3 pl-3">
                    Ielts Details
                  </h4>
                </div>
                <div className="form-wrap mc-border">
                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="preferred_test_date" className="form-label1">
                          Preferred date of Test
                        </label>
                        <input
                          id="preferred_test_date"
                          className="form-control form-input1"
                          name="preferred_test_date"
                          placeholder="Date of Test"
                          onChange={this.handleUserInput}
                          type="date"
                          value={this.state.ieltsDetails.preferred_test_date}
                        />
                        {this.validator.message('Date', this.state.ieltsDetails.preferred_test_date, 'required', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="second_test_date" className="form-label1">
                          Second Choice
                        </label>
                        <input
                          id="second_test_date"
                          className="form-control form-input1"
                          type="date"
                          name="second_test_date"
                          placeholder="Second Choice"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.second_test_date}
                        />
                        {this.validator.message('Date', this.state.ieltsDetails.second_test_date, 'required', { className: 'text-danger' })}
                      </div>
                    </div>
                  </div>
                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="title" className="form-label1">
                          Title
                        </label>
                        <input
                          id="title"
                          className="form-control form-input1"
                          type="text"
                          name="title"
                          placeholder="Title"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.title}
                         />
                            {this.validator.message('Title', this.state.ieltsDetails.title, 'required', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className="fr-right">
                    <div className="form-group">
                        <label htmlFor="city" className="form-label1">
                          Test City
                        </label>
                        <input
                          id="city"
                          className="form-control form-input1"
                          type="text"
                          name="city"
                          placeholder="Test City"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.city}
                        />
                        {this.validator.message('City', this.state.ieltsDetails.city, 'required', { className: 'text-danger' })}
                      </div>
                    </div>
                  </div>
                  
                  <div className="f-row">
                    <div className="fr-left">
                    <div className="form-group">
                        <label htmlFor="first_name" className="form-label1">
                          First Name
                        </label>
                        <input
                          id="first_name"
                          className="form-control form-input1"
                          type="first_name"
                          name="first_name"
                          placeholder="First Name"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.first_name}
                        />
                           {this.validator.message('First Name', this.state.ieltsDetails.first_name, 'required', { className: 'text-danger' })}
                      </div>
                      
                    </div>
                    <div className="fr-right">
                    <div className="form-group">
                        <label htmlFor="last_name" className="form-label1">
                          Last Name
                        </label>
                        <input
                          id="last_name"
                          className="form-control form-input1"
                          type="text"
                          name="last_name"
                          placeholder="Last Name"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.last_name}
                        />
                         {this.validator.message('Last Name', this.state.ieltsDetails.last_name, 'required', { className: 'text-danger' })}
                      </div>
                     
                    </div>
                  </div>
                 
                  <div className="row">
                    <div className="col-md-12">
                      <label htmlFor="test_module" className="form-label1">
                        Which ielts test module are you taking?
                      </label>
                      <div className="d-flex flex-md-row flex-column flex-wrap align-items-lg-center">
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="ielts_module"
                              value="1"
                              id="academic"
                              onChange={this.handleUserInput} 
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="academic"
                                className="label-radio mt-1"
                              >
                                Academic
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group ml-lg-4">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="ielts_module"
                              value="2"
                              id="generaltraining"
                              onChange={this.handleUserInput} 
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="generaltraining"
                                className="label-radio mt-1"
                              >
                                General Training
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.validator.message('Test module', this.state.ieltsDetails.ielts_module, 'required', { className: 'text-danger' })}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="address" className="form-label1">
                          Address
                        </label>
                        <textarea
                          name="address"
                          id="address"
                          rows="5"
                          className="form-control form-input1"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.address}
                        ></textarea>
                        {this.validator.message('Address', this.state.ieltsDetails.address, 'required', { className: 'text-danger' })}
                      </div>
                    </div>
                  </div>

                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="telephone" className="form-label1">
                          Telephone
                        </label>
                        <input
                          id="telephone"
                          className="form-control form-input1"
                          name="telephone"
                          placeholder="Telephone" 
                          type="text"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.telephone}                          
                        />
                         {this.validator.message('Test module', this.state.ieltsDetails.telephone, 'required|phone', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="mobile_number" className="form-label1">
                          Mobile Number
                        </label>
                        <input
                          id="mobile_number"
                          className="form-control form-input1"
                          type="text"
                          name="mobile_number"
                          placeholder=" Mobile Number"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.mobile_number}
                        />
                         {this.validator.message('Mobile Number', this.state.ieltsDetails.mobile_number, 'required|phone', { className: 'text-danger' })}
                      </div>
                    </div>
                  </div>

                  <div className="f-row">
                    <div className="fr-left"> 
                      <div className="form-group">
                        <label htmlFor="email" className="form-label1">
                          Email
                        </label>
                        <input
                          id="email"
                          className="form-control form-input1"
                          type="text"
                          name="email"
                          placeholder="Email"
                          onChange={this.handleUserInput} 
                          value={this.state.ieltsDetails.email}
                        />
                        {this.validator.message('Email', this.state.ieltsDetails.email, 'required|email', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="zip_code" className="form-label1">
                          Zip Code
                        </label>
                        <input
                          id="zip_code"
                          className="form-control form-input1"
                          type="text"
                          name="zip_code"
                          placeholder="Zip Code"
                          onChange={this.handleUserInput} 
                          value={this.state.ieltsDetails.zip_code}
                        />
                         {this.validator.message('Zipcode', this.state.ieltsDetails.zip_code, 'required|numeric', { className: 'text-danger' })}
                      </div>
                    </div>
                  </div>

                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="dob" className="form-label1">
                          Date of Birth
                        </label>
                        <input
                          id="dob"
                          className="form-control form-input1"
                          type="date"
                          name="dob"
                          placeholder="Date of Birth"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.dob}
                        />
                         {this.validator.message('Dob', this.state.ieltsDetails.dob, 'required', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="gender" className="form-label1">
                          Gender
                        </label>
                        <select
                          className="form-control form-input1"
                          name="gender"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.gender}
                        >
                          <option value="m">Male</option>
                          <option value="f">Female</option>
                        </select>
                      </div>
                    </div>
                  </div>
                   
                  <div className="row">
                    <div className="col-md-12">
                      <label htmlFor="identity_proof" className="form-label1">
                      Please indicate which document you will be using as proof of identity and give the number below.
                      </label>
                      <div className="d-flex flex-md-row flex-column flex-wrap align-items-lg-center">
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="identity_proof"
                              value="1"
                              id="passport"
                              onChange={this.handleUserInput} 
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="passport"
                                className="label-radio mt-1"
                              >
                                Passport
                              </label>
                            </div>
                          </div>
                           
                        </div>
                        <div className="form-group ml-md-4">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="identity_proof"
                              value="2"
                              id="nationalidentity_card"
                              onChange={this.handleUserInput} 
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="nationalidentity_card"
                                className="label-radio mt-1"
                              >
                                National Identity Card
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.validator.message('Identity Proof', this.state.ieltsDetails.identity_proof, 'required', { className: 'text-danger' })}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label
                          htmlFor="identity_number"
                          className="form-label1"
                        >
                          Passport or National Identity Card Number
                        </label>
                        <input
                          id="identity_number"
                          className="form-control form-input1"
                          type="text"
                          name="identity_number"
                          placeholder=" Passport or National Identity Card Number"
                          onChange={this.handleUserInput}
                        />
                         {this.validator.message('Card Number', this.state.ieltsDetails.identity_number, 'required|numeric', { className: 'text-danger' })}
                      </div>
                    </div>
                  </div>
                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="nationality" className="form-label1">
                          Country of Nationality (name)
                        </label>
                        <input
                          id="nationality"
                          className="form-control form-input1"
                          type="text"
                          name="nationality"
                          placeholder="Country Name" 
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.nationality}
                        />
                        {this.validator.message('Nationality', this.state.ieltsDetails.nationality, 'required|alpha', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="nationality_code" className="form-label1">
                          Country of Nationality (code)
                        </label>
                        <input
                          id="nationality_code"
                          className="form-control form-input1"
                          type="text"
                          name="nationality_code"
                          placeholder="Country Code"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.nationality_code}
                        />
                         {this.validator.message('Code', this.state.ieltsDetails.nationality_code, 'required|numeric', { className: 'text-danger' })}
                      </div>
                    </div>
                  </div>
                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="language" className="form-label1">
                          First Language (name)
                        </label>
                        <input
                          id="language"
                          className="form-control form-input1"
                          type="text"
                          name="language"
                          placeholder="Language Name"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.language}
                        />
                          {this.validator.message('Language', this.state.ieltsDetails.language, 'required|alpha', { className: 'text-danger' })}

                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="language_code" className="form-label1">
                          First Language (code)
                        </label>
                        <input
                          id="language_code"
                          className="form-control form-input1"
                          type="text"
                          name="language_code"
                          placeholder="Language Code"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.language_code}
                        />
                        {this.validator.message('Language', this.state.ieltsDetails.language_code, 'required|numeric', { className: 'text-danger' })}
                      </div>
                    </div>
                  </div>
                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="occupation_sector_id" className="form-label1">
                          Occupation Sector
                        </label>
                        <input
                          id="occupation_sector_id"
                          className="form-control form-input1"
                          type="text"
                          name="occupation_sector_id"
                          placeholder="Occupation Sector"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.occupation_sector_id}
                        />
                        {this.validator.message('Occupation Sector', this.state.ieltsDetails.occupation_sector_id, 'numeric', { className: 'text-danger' })}

                       </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="occupation_sector_other" className="form-label1">
                          If Other Please Specify
                        </label>
                        <input
                          id="occupation_sector_other"
                          className="form-control form-input1"
                          type="text"
                          name="occupation_sector_other"
                          placeholder="Other Sector"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.occupation_sector_other}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="occupation_level_id" className="form-label1">
                          Occupation Level
                        </label>
                        <input
                          id="occupation_level_id"
                          className="form-control form-input1"
                          type="text"
                          name="occupation_level_id"
                          placeholder="Occupation Level"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.occupation_level_id}
                        />
                        {this.validator.message('Occupation Sector', this.state.ieltsDetails.occupation_level_id, 'numeric', { className: 'text-danger' })}

                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="occupation_level_other" className="form-label1">
                          If Other Please Specify
                        </label>
                        <input
                          id="occupation_level_other"
                          className="form-control form-input1"
                          type="text"
                          name="occupation_level_other"
                          placeholder="Other Level"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.occupation_level_other}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="test_taking_id" className="form-label1">
                          Why are you taking test?
                        </label>
                        <input
                          id="test_taking_id"
                          className="form-control form-input1"
                          type="text"
                          name="test_taking_id"
                          placeholder="Description"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.test_taking_id}
                        />
                        {this.validator.message('Taking test', this.state.ieltsDetails.test_taking_id, 'numeric', { className: 'text-danger' })}

                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="test_taking_other" className="form-label1">
                          If Other Please Specify
                        </label>
                        <input
                          id="test_taking_other"
                          className="form-control form-input1"
                          type="text"
                          name="test_taking_other"
                          placeholder="Other Reason"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.test_taking_other}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <label htmlFor="identity_proof" className="form-label1">
                        Which country are you applying to/intending to go to?
                      </label>
                      <div className="form-radio-options">
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="country"
                              value="australia"
                              id="australia"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="australia"
                                className="label-radio mt-1"
                              >
                                Australia
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              htmlFor="canada"
                              name="country"
                              value="canada"
                              id="canada"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="canada"
                                className="label-radio mt-1"
                              >
                                Canada
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="country"
                              value="newzealand"
                              id="newzealand"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="newzealand"
                                className="label-radio mt-1"
                              >
                                New Zealand
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="country"
                              value="republicofireland"
                              id="republicofireland"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="republicofireland"
                                className="label-radio mt-1"
                              >
                                Republic of Ireland
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="country"
                              value="newzealand"
                              id="unitedkingdom"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="unitedkingdom"
                                className="label-radio mt-1"
                              >
                                United Kingdom
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="country"
                              value="republicofireland"
                              id="unitedstates"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="unitedstates"
                                className="label-radio mt-1"
                              >
                                United States of America
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="country"
                              value="republicofireland"
                              id="othercountary"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="othercountary"
                                className="label-radio mt-1"
                              >
                                Other Please Specify
                              </label>
                            </div>
                            <div className="ml-3 col-md-6">
                              <input
                                id="country_other"
                                className="form-control form-input1"
                                type="text"
                                name="country_other"
                                onChange={this.handleUserInput}
                                value={this.state.ieltsDetails.country_other}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.validator.message('Country', this.state.ieltsDetails.country, 'required', { className: 'text-danger' })}

                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="currently_studying_description" className="form-label1">
                          Where are you currently studying English (if
                          applicable)?
                        </label>
                        <textarea
                          name="currently_studying_description"
                          id="currently_studying_description"
                          rows="3"
                          className="form-control form-input1"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.currently_studying_description}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <label htmlFor="identityproof" className="form-label1">
                        What level of education have you completed?
                      </label>
                      <div className="form-radio-options">
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="eduction_level_id"
                              value="1"
                              id="level1"
                              onChange={this.handleUserInput} 
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="level1"
                                className="label-radio mt-1"
                              >
                                1 (or less than)
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="eduction_level_id"
                              value="2"
                              id="level2"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="level2"
                                className="label-radio mt-1"
                              >
                                2
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="eduction_level_id"
                              value="3"
                              id="level3"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="level3"
                                className="label-radio mt-1"
                              >
                                3
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="eduction_level_id"
                              value="4"
                              id="level4"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="level4"
                                className="label-radio mt-1"
                              >
                                4
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="eduction_level_id"
                              value="5"
                              id="level5"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="level5"
                                className="label-radio mt-1"
                              >
                                5
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="eduction_level_id"
                              value="6"
                              id="level6"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="level6"
                                className="label-radio mt-1"
                              >
                                6
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="eduction_level_id"
                              value="7"
                              id="level7"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="level7"
                                className="label-radio mt-1"
                              >
                                7
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="eduction_level_id"
                              value="8"
                              id="level8"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="level8"
                                className="label-radio mt-1"
                              >
                                8
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="eduction_level_id"
                              value="9"
                              id="level9"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label
                                htmlFor="level9"
                                className="label-radio mt-1"
                              >
                                9
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.validator.message('Education Level', this.state.ieltsDetails.eduction_level_id, 'required', { className: 'text-danger' })}

                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <label htmlFor="identity_proof" className="form-label1">
                        Do you have a permanent disability, such as a visual,
                        hearing or specific learning difficulty, which requires
                        special arrangements (for example, modified material,
                        extra time, use of technology, etc.)?
                      </label>
                      <div className="d-flex flex-md-row flex-column  align-items-md-center">
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="has_disability"
                              value="0"
                              id="yes"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label htmlFor="yes" className="label-radio mt-1">
                                Yes
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group ml-md-4">
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              name="has_disability"
                              value="1"
                              id="no"
                              onChange={this.handleUserInput}
                            />
                            <div className="ml-2 d-flex flex-column align-items-center">
                              <label htmlFor="no" className="label-radio mt-1">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.validator.message('Permanent disability', this.state.ieltsDetails.has_disability, 'required', { className: 'text-danger' })}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group mb-0">
                        <label htmlFor="disability_description" className="form-label1">
                          If yes, please specify your requirements below. You
                          must attach original supporting medical evidence to
                          this form. The medical evidence must be in the form of
                          a report prepared in a period no more than two years
                          before the test date. You must submit requests for
                          modified test materials at least six weeks before the
                          test.
                        </label>
                        <textarea
                          name="disability_description"
                          id="disability_description"
                          rows="2"
                          className="form-control form-input1"
                          onChange={this.handleUserInput}
                          value={this.state.ieltsDetails.disability_description}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mb-0 mt-4">
                    <input
                      type="file"
                      single="true"
                      hidden
                      name="document"
                      id="files"
                      onChange={this.handleUserInput}
                    />
                    <label
                      htmlFor="files"
                      type="button"
                      className="btn btn-docs"
                    >
                      Upload Docs
                    </label>
                    <span className="ml-2">
                      {this.state.dataFile.map((file, index) => {
                        return <span key={index}>{file.name}</span>;
                      })}
                    </span>
                     <div className="text-danger">
                      {this.state.error === true ? "Upload a file" : null}
                     </div>
                  </div>
               
                </div>
                <div className="form-group text-right mt-4">
                  <button type="button" className="btn btn-apply" onClick={this.submitForm}>
                    Submit
                  </button>
                </div>
                <CountryCodes />
                <LanguageCodes />
                <OccupationCodes />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {   
  return {
      onSetLoader: () => dispatch({type: 'SET_LOADER'}) 
  }
};

export default connect(null, mapDispatchToProps)(withRouter(Ilets));

